import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_dropdown_item, { to: "/patient" }, {
      default: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, { icon: "asterisk" }),
        _createElementVNode("span", {
          textContent: _toDisplayString(_ctx.t$('global.menu.entities.patient'))
        }, null, 8 /* PROPS */, _hoisted_1)
      ], undefined, true),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_b_dropdown_item, { to: "/measurement" }, {
      default: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, { icon: "asterisk" }),
        _createElementVNode("span", {
          textContent: _toDisplayString(_ctx.t$('global.menu.entities.measurement'))
        }, null, 8 /* PROPS */, _hoisted_2)
      ], undefined, true),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here ")
  ]))
}